<!-- LEFT SIDEBAR STRUCTURE -->
<div class="menu">
	<div class="icon" (click)="toggleMenu()">{{ expand ? 'close' : 'menu' }}</div>
</div>
<div class="items" [ngClass]="{ expand: expand }">
	<div class="item" [ngClass]="{ expand: expand }" (click)="goHome()">
		<div class="icon" title="Home">home</div>
		<div class="title" [ngClass]="{ expand: expand }">Home</div>
	</div>

	<div class="toggle" [ngClass]="{ expand: expand }">
		<div class="icon" (click)="toggleMenu()">{{ expand ? 'keyboard_double_arrow_left' : 'keyboard_double_arrow_right' }}</div>
	</div>
</div>

<footer [ngClass]="{ expand: expand }"></footer>
